module.exports = __webpack_public_path__ + "img/Abschied.0baae3b6.jpg";